import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {AfterViewInit, ChangeDetectorRef, Component} from "@angular/core";
import {AuthService, EntityModelStatus, provideEntityModel} from "@fedeltapointofsale/data-client";
import {OutletEntityModel} from "../outlet-entity.model";
import {OutletData, OutletExternalNameType} from "../outlet.data";
import {EditPageActionEvent} from "../../../framework/entity/edit/edit-page/edit-page-action.event";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {AddressData} from "../../../address/address.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {first} from "rxjs";

@Component({
    selector: "outlet-edit-page",
    templateUrl: "./outlet-edit-page.component.html",
    providers: [provideEntityModel(OutletEntityModel)]
})
export class OutletEditPageComponent extends AbstractEditPage implements AfterViewInit {

    OutletExternalNameType = OutletExternalNameType;
    fixedOutletGroupId: number;

    constructor(public model: OutletEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                public authService: AuthService) {
        super(changeDetectorRef, responsiveService);
    }

    ngAfterViewInit(): void {
        if (this.model.status === EntityModelStatus.INSERT && this.editParams) {
            this.fixedOutletGroupId = this.editParams["outletGroupId"];
            if (this.fixedOutletGroupId) {
                this.model.$data.pipe(first()).subscribe(() => this.model.data.outletGroupId = this.fixedOutletGroupId);
            }
            this.changeDetectorRef.detectChanges();
        }
    }

    saved(event: EditPageActionEvent): void {
        if (event.editMode == EditMode.ADD) {
            event.actionComplete = this.authService.refreshAccessToken().toPromise();
        }
    }

    addingAnother(previousEntity: OutletData): void {
        this.model.data.outletGroupId = previousEntity.outletGroupId;
        this.model.data.companyDetailsId = previousEntity.companyDetailsId;
    }

    get pickupTelephone(): string {
        return this.model.data.useCompanyAddressForPickup ? this.model.data.companyDetails.telephone : this.model.data.pickupTelephone;
    }

    set pickupTelephone(telephone: string) {
        if (!this.model.data.useCompanyAddressForPickup) {
            this.model.data.pickupTelephone = telephone;
        }
    }

    get pickupAddress(): AddressData {
        return this.model.data.useCompanyAddressForPickup ? this.model.data.companyDetails.address : this.model.data.pickupAddress;
    }

    get deliveryTelephone(): string {
        return this.model.data.useCompanyAddressForDelivery ? this.model.data.companyDetails.telephone : this.model.data.deliveryTelephone;
    }

    set deliveryTelephone(telephone: string) {
        if (!this.model.data.useCompanyAddressForDelivery) {
            this.model.data.deliveryTelephone = telephone;
        }
    }

    get deliveryAddress(): AddressData {
        return this.model.data.useCompanyAddressForDelivery ? this.model.data.companyDetails.address : this.model.data.deliveryAddress;
    }

    clearCompanyDetails(): void {
        this.model.data.useCompanyAddressForPickup = false;
        this.model.data.useCompanyAddressForDelivery = false;
    }
}
